import React from 'react';

export default function GenericBoard({
                                       items = [], // JSX 배열들의 배열
                                       columns = [], // 각 열의 레이아웃 설정 객체 배열
                                       // 행 전체를 클릭 가능하게 만든다. (rowIndex) => void.
                                       // 넘기지 않으면 종전과 완전히 동일하게 동작한다(다른 목록 화면 영향 없음).
                                       // 행 안의 버튼·아이콘은 각자 onClick 에서 e.stopPropagation() 으로 빠져나가야 한다.
                                       onRowClick = null
                                   }) {
    const clickable = typeof onRowClick === 'function';

    return (
        <div className="w-full bg-gray-50/50 p-4 font-sans">
            <div className="mx-auto flex flex-col gap-3">

                {items.map((rowElements, rowIndex) => (
                    <div
                        key={rowIndex}
                        onClick={clickable ? () => onRowClick(rowIndex) : undefined}
                        // 마우스 없이도 열 수 있어야 한다(접근성). Enter/Space 는 브라우저 기본 스크롤을 막고 처리.
                        role={clickable ? 'button' : undefined}
                        tabIndex={clickable ? 0 : undefined}
                        onKeyDown={clickable ? (e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onRowClick(rowIndex);
                            }
                        } : undefined}
                        className={"group relative flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-6 p-4 sm:p-5 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:border-blue-300 hover:-translate-y-0.5 transition-all duration-300"
                            + (clickable ? " cursor-pointer" : "")}
                    >
                        {rowElements.map((element, colIndex) => {

                            // 파라미터로 전달받은 컬럼 설정 가져오기 (설정이 없으면 기본값 적용)
                            const colConfig = columns[colIndex] || { align: 'left', flex: false };

                            // 1. 정렬(Align) 클래스 처리
                            const alignClass =
                                colConfig.align === 'center' ? 'justify-center text-center' :
                                    colConfig.align === 'right' ? 'justify-end text-right' :
                                        'justify-start text-left'; // 기본값 left

                            // 2. 확장(Flex) 클래스 처리 (제목처럼 남는 공간을 다 차지해야 할 때)
                            const flexClass = colConfig.flex ? 'flex-1 min-w-0' : 'flex-shrink-0';

                            // 3. 고정 너비(Width) 클래스 처리 (Tailwind 클래스 직접 주입)
                            const widthClass = colConfig.width || '';

                            return (
                                <div
                                    key={colIndex}
                                    className={`flex items-center h-full ${alignClass} ${flexClass} ${widthClass}`}
                                >
                                    {element}
                                </div>
                            );
                        })}
                    </div>
                ))}

                {items.length === 0 && (
                    <div className="flex flex-col items-center justify-center py-20 bg-white rounded-2xl border border-gray-100 border-dashed">
                        <p className="text-gray-400 font-medium">표시할 데이터가 없습니다.</p>
                    </div>
                )}
            </div>
        </div>
    );
}